import { useForm } from 'react-hook-form';



export default function Authentication(){
    const { register, handleSubmit, formState:{errors} } = useForm();

    //const {token, setToken} = useToken();
    const onSubmit = data =>{
        const username = data.userName;
        const password = data.Pwd;

        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body:JSON.stringify({username: username, password:password })
        };

        const AuthURL = process.env.NODE_ENV === 'development'?process.env.REACT_APP_API_URL_DEV_MODE + 'api/login/': process.env.REACT_APP_API_URL_PROD_MODE + 'api/login/';


        fetch(AuthURL, requestOptions)
            .then(response => {
                if(response.ok)
                    return response.json();
                throw response;
            })
            .then(data => {
                setToken(data.token, data.user, data.territory, data.tenancy);
                window.location.replace(process.env.NODE_ENV === 'development'?process.env.REACT_APP_URL_DEV_MODE:process.env.REACT_APP_URL_PROD_MODE);
            })
            .catch ((error)=>{
                setToken("");
                let errMsg="";
                switch (error.status){
                    default:
                        errMsg="An error has occured. Please try again";
                    case '400':
                        errMsg = "Please enter both username and password";
                    case '404':
                        errMsg="Incorrect Email or Password entered!"
                }
                alert(errMsg);
            });
    
    }
    

    function setToken(userToken, userId, territory, tenancy, ){
        localStorage.setItem('token', JSON.stringify(userToken))
        localStorage.setItem('user', JSON.stringify(userId))
        localStorage.setItem('territory', JSON.stringify(territory))
        localStorage.setItem('tenancy', JSON.stringify(tenancy))
    }


    return (
        <>
            <form className="frm flex flex-col justify-left items-left" onSubmit={handleSubmit(onSubmit)}>
                
                <label className="lbl" htmlFor="userName">Email</label>
                <input className="txt mb-2" type="text" id="userName" name="userName" placeholder="Email" {...register("userName", {required:"Please enter your email"})} />
                <span className="errortxt">{errors.userName?.message}</span>
                   
                
                <label className="lbl" htmlFor="Pwd">Password</label>
                <input className="txt" type="password" id="Pwd" name="Pwd" placeholder="Password" {...register("Pwd", {required:"Please enter the password"})} />
                <span className="errortxt">{errors.Pwd?.message}</span>
                
                 
                
                <input className="btn font-semibold  flex-grow" type="submit" value="Login" />
            </form>
        </>


    );


}